import { useState, useEffect } from 'react';
import { useAppSelector } from 'app/hooks';
import { selectFlow } from 'features/data-product-builder/reducers/builderSlice';
import { selectCreateNewProject } from 'app/sharedSlice';
import type { IStep } from 'utils/types';

const defaultSteps: IStep[] = [
  {
    name: 'Project setup',
    description: 'CI/CD configuration',
    disabled: false,
  },
  {
    name: 'Database selection',
    description: 'Which database would you like to create infrastructure configurations from?',
    disabled: false,
  },
  {
    name: 'Dataset schema',
    description: 'Which Snowflake objects would you like to generate configurations for?',
    disabled: false,
  },
  {
    name: 'Configuration editor',
    description: 'Make changes to the SOLE configuration',
    disabled: false,
  },
  {
    name: 'Summary',
    description: 'The infrastructure-as-code configurations will be generated for the following selected objects',
    disabled: false,
  },
];

export default function useCiCdFlowSteps(): IStep[] {
  const flow = useAppSelector(selectFlow);
  const createNewProject = useAppSelector(selectCreateNewProject);
  const [steps, setSteps] = useState<IStep[]>(defaultSteps);

  useEffect(() => {
    let tmpSteps = [...defaultSteps];

    if (flow === 'ddl' || flow === 'example-ddl' || !createNewProject) {
      tmpSteps.splice(1, 2);
    }

    if (createNewProject) {
      tmpSteps = tmpSteps.filter((step) => step.name !== 'Configuration editor');
    }

    setSteps(tmpSteps);

    setSteps(tmpSteps);
  }, [flow, createNewProject]);

  return steps;
}
